import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('compute.text_1047', [i18n.t('dictionary.server')]),
        permission: 'server_create',
        action: obj => {
          this.$router.push({
            path: '/servertemplate-container/create-server',
            query: {
              id: obj.id,
            },
          })
        },
        meta: obj => {
          const isReady = obj.status === 'ready'
          return {
            validate: isReady,
            tooltip: !isReady && i18n.t('compute.text_1048'),
          }
        },
      },
      {
        label: i18n.t('compute.perform_delete'),
        permission: 'servertemplates_delete',
        action: obj => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: i18n.t('compute.perform_delete'),
            onManager: this.onManager,
            name: this.$t('compute.servertemplate_container'),
          })
        },
        meta: obj => this.$getDeleteResult(obj),
      },
    ]
  },
}
